module.exports = __webpack_public_path__ + "img/9.c3905e67.jpg";